import { render, staticRenderFns } from "./EditBankAccountName.vue?vue&type=template&id=0f5336ac&scoped=true&"
import script from "./EditBankAccountName.vue?vue&type=script&lang=js&"
export * from "./EditBankAccountName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5336ac",
  null
  
)

export default component.exports